module.exports = __webpack_public_path__ + "static/img/return_empty.fb895ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/return_empty.png
// module id = Inc3
// module chunks = 1